import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import KMLUpload from "../assets/images/KMLUplode.png";
import coordinatesIcon from "../assets/images/coordinates.png";
import currentLocationIcon from "../assets/images/currentLocationIcon.png";
import cursorIcon from "../assets/images/hover-coordinates.png";
import WorldView from "../assets/images/world-view.png";
import CountryDropdown from "../assets/images/country-dropdown.png";
import Countries from '../assets/countriesJSON/countries.json'; 
import aoiIcon from "../assets/images/aoi.png";
import UAVSphere_logo from "../assets/images/UAVspherelogo1.jpg";

function MapSidebar({ onKMLUpload, setCurrentLocationMarkerPosition, setCenter,setMarkerPosition,setCaptureCoordinates, setZoomLevel,setKmlUrl,zoomToDrawnShapes}) {
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [selectedIcon, setSelectedIcon] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [showSetCoordinatesPopup, setshowSetCoordinatesPopup] = useState(false);
  const [isWorldView, setIsWorldView] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const handleDefaultView = () => {
    if (!isWorldView) {
      setZoomLevel(12); // Set zoom level to 12 for default view
      }
  };

  const handleSetCoordinates = () => {
    const lat = parseFloat(latitude);
    const lng = parseFloat(longitude);

    if (!isNaN(lat) && !isNaN(lng)) {
      setCenter({ lat, lng }); // Update the center of the map
      setMarkerPosition({ lat, lng }); // Set the marker position
      setshowSetCoordinatesPopup(false); // Close the popup after setting coordinates
      if (isWorldView) {
        setZoomLevel(12); // Zoom in when coming from world view
        setIsWorldView(false); // Reset world view flag after zooming in
      }
    } else {
      alert("Please enter valid coordinates");
    }
  };

  const handleCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setCenter({ lat: latitude, lng: longitude });
        setCurrentLocationMarkerPosition({ lat: latitude, lng: longitude }); // Set the marker position
        
        if (isWorldView) { 
          setZoomLevel(15); // Zoom in when coming from world view
          setIsWorldView(false); // Reset world view flag after zooming in
        }
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  const handleIconClick = (icon) => {
    setSelectedIcon(icon);
    handleDefaultView();
    if (icon === "KMLUpload") {
      setShowPopup(true);
    } 
  };

  const handleWorldView = () => {    
    setTimeout(() => {
      setCenter({ lat: 0, lng: 0 });
      setZoomLevel(2); // Set zoom level to 2 for world view
      setIsWorldView(true);
    }, 100);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file && onKMLUpload) {
      onKMLUpload(file);
    }
    setShowPopup(false); // Close the popup after file selection
  };

  const handleCountrySelect = (event) => {
    const country = event.target.value;
    setSelectedCountry(country);
   // const kmlUrl=`https://kmlgenerationgeowgs84.blob.core.windows.net/kml-storage/${country}.kml`;
   const formattedCountry = country.replace(/\s+/g, '%20'); // Replaces spaces with %20
   const kmlUrl = `https://kmlgenerationgeowgs84.blob.core.windows.net/wourld-country-area-kml-files/${formattedCountry}.kml`;
    //https://kmlgenerationgeowgs84.blob.core.windows.net/wourldcountryarea-kml-files/Afghanistan.kml
    setKmlUrl(kmlUrl);
    setShowDropdown(false);
  };

  const handleCancel = () => {
    setShowPopup(false);
    setshowSetCoordinatesPopup(false);
    setShowDropdown(false);
  };

  const handleCursorCapture = () => {
    setCaptureCoordinates((prev) => !prev);
  };

  return (
    <div className="mapsidebar">
      <img 
          src={UAVSphere_logo} 
          alt="UAVSphere Logo" 
      />
      <img
        src={coordinatesIcon}
        alt="Coordinates Icon"
        className={`sidebar-logo ${selectedIcon === "coordinates" ? "selected" : ""}`}
        title="Navigate to Set coordinates"
        onClick={() => {
          setshowSetCoordinatesPopup(true);
          if (!isWorldView) { 
            handleDefaultView(); 
          }          
          handleIconClick("coordinates");
        }}
      />
      <img
        src={currentLocationIcon}
        alt="Current Location Icon"
        className={`sidebar-logo ${selectedIcon === "currentLocation" ? "selected" : ""}`}
        title="Navigate to Current Location"
        onClick={() => {
          handleCurrentLocation();
          handleDefaultView(); 
          handleIconClick("currentLocation");
        }}
      />
      <img
        src={cursorIcon}
        alt="Capture Coordinates Icon"
        className={`sidebar-logo ${selectedIcon === "cursor" ? "selected" : ""}`}
        title="Navigate to Capture Coordinates"
        onClick={() => {
          handleCursorCapture();
        // handleDefaultView(); 
          handleIconClick("cursor");
        }}
      />
        <img
          src={WorldView}
          alt="World View Icon"
          className={`sidebar-logo ${selectedIcon === "worldView" ? "selected" : ""}`}
          title="Navigate to World View"
          onClick={() => {
            handleWorldView(); 
            handleIconClick("worldView");
            //handleDefaultView(); 
          }}
        /> 

     <img
      src={aoiIcon}
      alt="AOI"
      className={`sidebar-logo ${selectedIcon === "aoi" ? "selected" : ""}`}
      title="Navigate Zoom To The AOI"
      onClick={() => {
        zoomToDrawnShapes();
        handleIconClick("aoi");
      }}
    />  
      <div className="divider"></div>
    <img
      src={KMLUpload}
      alt="Upload KML"
      className={`sidebar-logo ${selectedIcon === "KMLUpload" ? "selected" : ""}`}
      title="KML Upload"
      onClick={() => handleIconClick("KMLUpload")}
    />
        <img
        src={CountryDropdown}
        alt="CountryDropdown Icon"
        className={`sidebar-logo ${selectedIcon === "CountryDropdown" ? "selected" : ""}`}
        title="Select your service area as a country"
        onClick={() => {
        setShowDropdown(true);
        if (!isWorldView) { 
            handleDefaultView(); 
          }
          handleIconClick("CountryDropdown");
        }}
      />   
      {showDropdown && (
        <div className="popup-overlay" onClick={handleCancel}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h2>Select a Country</h2>
            <select value={selectedCountry} onChange={handleCountrySelect}>
              <option value="">Select a country</option>
              {Object.entries(Countries).map(([key, value], index) => (
              <option key={index} value={key}>
                {value}
                </option>
              ))}
            </select>
            <div className="popup-buttons">
              <Button onClick={handleCancel}>Close</Button>
            </div>
          </div>
        </div>
      )} 
      {showPopup && (
        <div className="popup-overlay" onClick={handleCancel}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h2>Upload KML File</h2>
            <div className="popup-field">
              <input
                type="file"
                accept=".kml"
                onChange={handleFileUpload}
              />
            </div>
            <button onClick={handleCancel}>Close</button>
          </div>
        </div>
      )}
        {showSetCoordinatesPopup && (
        <div className="popup-overlay" onClick={handleCancel}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h2>Set Coordinates</h2>
            <div className="popup-field">
              <label htmlFor="latitude">Latitude:</label>
              <input
                id="latitude"
                type="text"
                placeholder="Enter Latitude"
                value={latitude}
                onChange={(e) => setLatitude(e.target.value)}
              />
            </div>
            <div className="popup-field">
              <label htmlFor="longitude">Longitude:</label>
              <input
                id="longitude"
                type="text"
                placeholder="Enter Longitude"
                value={longitude}
                onChange={(e) => setLongitude(e.target.value)}
              />
            </div>
            <div className="popup-buttons">
              <Button onClick={handleSetCoordinates}>Take Me</Button>
              <Button onClick={handleCancel}>Close</Button>
            </div>
          </div>
        </div>
      )}     
    </div>
  );
}

export default MapSidebar;
